import { IdName } from 'src/app/shared/models/id-name';

export const CHEMICAL_EXPOSURE_MAX_LENGTH = {
  substanceName: 200,
  manufacturerName: 200,
  exposureLocation: 500,
};

export interface IChemicalExposureRequest {
  exposureDurationId: string;
  exposurePlacement: number;
  exposureLocation: string;
  safetyDataSheetConfirmed: boolean;
  substanceName?: string;
  manufacturerName?: string;
  exposedUserIds?: string[];
  exposedAt?: string;
}

export interface IChemicalExposureFormValue {
  exposureDurationId: string;
  exposurePlacement: number | null;
  exposureLocation: string;
  safetyDataSheetConfirmed: boolean;
  substanceName: string;
  manufacturerName: string;
  exposedAt: Date | null;
  exposedUserIds: string[];
}

export interface IChemicalExposureDefaults {
  exposureDurationId?: string;
  exposurePlacement?: number | null;
  exposureLocation?: string;
  safetyDataSheetConfirmed?: boolean;
  substanceName?: string;
  manufacturerName?: string;
  exposedAt?: Date | string;
  exposedUserIds?: string[];
}

export interface IChemicalExposureLogPerson {
  employmentId: string;
  userId?: string;
  name: string;
  position: string;
}

export interface IUserChemicalExposureLogItem {
  id: string;
  exposedAt: string;
  substanceName: string;
  manufacturerName: string;
  exposurePlacement: number;
  exposureLocation: string;
  safetyDataSheetConfirmed: boolean;
  exposureDuration: IdName;
  quantityWithdrawn?: number;
  quantityType?: IdName;
  department: IdName;
  position?: string;
  registeredBy?: string;
  exposedUsers?: IdName[];
  exposedPersons?: IChemicalExposureLogPerson[];
  exposedPositions?: string[];
  storageProductId?: string;
  storageProductVersionId?: string;
}

export interface IChemicalExposureLogUpdateRequest {
  exposureDurationId: string;
  exposurePlacement: number;
  exposureLocation: string;
  exposedUserIds: string[];
  safetyDataSheetConfirmed: boolean;
  exposedAt?: string;
}
